var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorMomentum0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "304.5px",
    height: "184.833px",
    viewBox: "0 0 304.5 184.833",
    enableBackground: "new 0 0 304.5 184.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mom0_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M182.904,82.708v-0.051c0.162,0.033,0.33,0.051,0.5,0.051c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5 c-0.17,0-0.338,0.018-0.5,0.05v-0.05h-25v5H182.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M209.205,67.708v-0.021c0.068,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.131,0.014-0.199,0.02v-0.02h-51v5H209.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M236.205,52.708c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5h-78v5H236.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M263.205,37.708v-0.021c0.066,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.133,0.014-0.199,0.02v-0.02h-105v5H263.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M290.436,22.708v-0.004c1.367-0.018,2.469-1.127,2.469-2.496c0-1.371-1.102-2.48-2.469-2.498v-0.002 H157.904v5H290.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 290.436,
    cy: 171.251,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 263.506,
    cy: 171.251,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 236.506,
    cy: 171.251,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 209.506,
    cy: 171.251,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 182.654,
    cy: 171.251,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 156.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 151.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 146.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 141.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 136.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 131.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 126.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 121.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 116.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 111.213,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 106.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 101.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 96.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 156.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 151.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 146.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 141.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 136.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 131.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 126.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 121.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 116.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 111.213,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 106.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 101.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 96.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 156.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 151.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 146.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 141.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 136.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 131.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 126.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 121.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 116.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 111.213,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 106.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 101.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.506,
    y: 96.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 156.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 151.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 146.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 141.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 136.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 131.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 126.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 121.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 116.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 111.213,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 106.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 101.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 96.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 156.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 151.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 146.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 141.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 136.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 131.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 126.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 121.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 116.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 111.213,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 106.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 101.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 96.214,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.654,
    y: 85.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 85.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 80.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 75.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.506,
    y: 70.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 85.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 80.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 75.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 70.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 65.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 60.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.652,
    y: 55.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 85.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 80.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 75.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 70.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 65.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 60.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 55.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 50.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 45.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.506,
    y: 40.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 85.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 80.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 75.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 70.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 65.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 60.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 55.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 50.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 45.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 40.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 35.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 30.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.436,
    y: 25.708,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 2.146,
    fill: "#1C75BC",
    width: 2,
    height: 179.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 91.479,
    fill: "#1C75BC",
    width: 300,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EE2929",
    d: "M123.67,101.979v0.051c-0.162-0.033-0.328-0.051-0.5-0.051c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5c0.172,0,0.338-0.018,0.5-0.051v0.051h25v-5H123.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D12727",
    d: "M97.369,116.979v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h51v-5H97.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B52625",
    d: "M70.369,131.979c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5h78v-5H70.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96201F",
    d: "M43.369,146.979v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h105v-5H43.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#721919",
    d: "M16.139,161.979v0.004c-1.365,0.018-2.469,1.127-2.469,2.496c0,1.371,1.104,2.48,2.469,2.498v0.002 H148.67v-5H16.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#721919",
    cx: 16.139,
    cy: 13.436,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#96201F",
    cx: 43.068,
    cy: 13.436,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B52625",
    cx: 70.068,
    cy: 13.436,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12727",
    cx: 97.068,
    cy: 13.436,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EE2929",
    cx: 123.922,
    cy: 13.436,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 25.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 30.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 35.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 40.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 45.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 50.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 55.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 60.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 65.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 70.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 75.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 80.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 85.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 25.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 30.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 35.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 40.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 45.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 50.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 55.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 60.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 65.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 70.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 75.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 80.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 85.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 25.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 30.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 35.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 40.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 45.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 50.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 55.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 60.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 65.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 70.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 75.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 80.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.068,
    y: 85.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 25.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 30.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 35.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 40.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 45.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 50.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 55.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 60.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 65.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 70.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 75.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 80.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 85.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 25.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 30.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 35.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 40.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 45.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 50.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 55.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 60.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 65.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 70.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 75.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 80.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 85.474,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.922,
    y: 95.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 95.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 100.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 105.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.068,
    y: 110.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 95.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 100.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 105.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 110.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 115.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 120.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.922,
    y: 125.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 95.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 100.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 105.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 110.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 115.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 120.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 125.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 130.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 135.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.068,
    y: 140.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 95.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 100.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 105.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 110.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 115.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 120.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 125.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 130.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 135.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 140.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 145.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 150.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.139,
    y: 155.979,
    fill: "#EE2929",
    width: 2,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M12.383,12.989c0-1.465,0.357-2.703,1.072-3.713c0.715-1.012,1.672-1.517,2.867-1.517 c2.496,0,3.744,1.821,3.744,5.464c0,1.704-0.338,3.064-1.012,4.08s-1.619,1.523-2.834,1.523c-1.309,0-2.275-0.469-2.9-1.406 S12.383,15.006,12.383,12.989z M14.359,13.121c0,1.431,0.141,2.483,0.418,3.157c0.279,0.674,0.74,1.01,1.385,1.01 c0.697,0,1.193-0.303,1.486-0.912c0.293-0.607,0.439-1.689,0.439-3.248c0-1.449-0.141-2.451-0.42-3.002 c-0.281-0.553-0.742-0.828-1.381-0.828C15.002,9.298,14.359,10.572,14.359,13.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M41.584,18.822v-7.734l-2.182,1.312v-1.832c1.4-0.678,2.51-1.518,3.324-2.52h0.762v10.774H41.584z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M66.969,18.681v-0.557l3.398-5.003c0.678-1.001,1.018-1.843,1.018-2.526 c0-0.811-0.486-1.217-1.457-1.217c-0.742,0-1.34,0.394-1.795,1.18l-1.281-1.011c0.254-0.513,0.652-0.938,1.197-1.278 c0.545-0.339,1.146-0.509,1.805-0.509c1.1,0,1.959,0.251,2.578,0.751c0.621,0.5,0.932,1.195,0.932,2.084 c0,0.814-0.398,1.83-1.195,3.047l-2.197,3.347H74v1.692H66.969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M93.715,17.779l0.951-1.472c0.566,0.6,1.182,0.9,1.846,0.9c1.211,0,1.816-0.568,1.816-1.707 c0-0.518-0.176-0.938-0.527-1.264c-0.352-0.324-0.824-0.486-1.42-0.486h-0.338v-1.567h0.285c1.094,0,1.641-0.456,1.641-1.37 c0-0.957-0.51-1.436-1.529-1.436c-0.527,0-1.041,0.25-1.539,0.748l-0.893-1.312c0.229-0.283,0.588-0.53,1.076-0.739 c0.488-0.211,0.977-0.315,1.465-0.315c1.068,0,1.902,0.244,2.5,0.732c0.6,0.488,0.898,1.172,0.898,2.051 c0,1.045-0.449,1.841-1.348,2.388c1.137,0.547,1.707,1.44,1.707,2.681c0,1.021-0.34,1.812-1.016,2.373 s-1.609,0.843-2.801,0.843C95.406,18.827,94.48,18.478,93.715,17.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M125.877,15.875v2.806h-1.83v-2.806h-4.887v-1.091l5.883-6.878h0.834v6.46h1.084v1.509H125.877z  M124.047,11.144l-2.754,3.223h2.754V11.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M179.314,175.62l0.754-1.568c0.775,0.605,1.443,0.908,2,0.908c1.23,0,1.846-0.756,1.846-2.27 c0-0.729-0.141-1.258-0.418-1.594c-0.279-0.334-0.744-0.502-1.398-0.502c-0.592,0-1.168,0.291-1.729,0.873l-0.756-0.492v-5.316 h5.779v1.619h-3.947v1.918c0.322-0.146,0.707-0.219,1.156-0.219c1.055,0,1.867,0.305,2.436,0.914 c0.568,0.611,0.854,1.475,0.854,2.594c0,2.729-1.271,4.094-3.816,4.094C181.02,176.579,180.1,176.259,179.314,175.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M209.965,165.491l1.01,1.068c-0.727,0.381-1.389,0.881-1.984,1.502 c-0.596,0.619-1.006,1.232-1.23,1.838c0.508-0.229,0.947-0.344,1.318-0.344c1.012,0,1.822,0.314,2.436,0.941 s0.92,1.475,0.92,2.545c0,1.055-0.314,1.908-0.941,2.561c-0.629,0.65-1.42,0.977-2.377,0.977c-2.5,0-3.75-1.561-3.75-4.68 c0-1.309,0.482-2.633,1.445-3.973C207.775,166.585,208.826,165.774,209.965,165.491z M207.342,173.005 c0,1.305,0.555,1.955,1.664,1.955c0.453,0,0.814-0.162,1.084-0.486c0.268-0.324,0.402-0.777,0.402-1.359 c0-0.596-0.141-1.066-0.422-1.416s-0.643-0.523-1.088-0.523C207.889,171.175,207.342,171.784,207.342,173.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M236.039,177.147h-2.088c0.795-2.451,2.162-5.457,4.102-9.018h-4.914v-1.758h7.396v0.814l-0.967,1.822 c-0.316,0.615-0.652,1.289-1.004,2.02c-0.352,0.729-0.693,1.471-1.025,2.227c-0.332,0.754-0.625,1.459-0.879,2.115 C236.406,176.028,236.199,176.62,236.039,177.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M261.684,170.56c-0.391-0.264-0.711-0.613-0.959-1.049c-0.25-0.434-0.373-0.869-0.373-1.303 c0-0.826,0.291-1.48,0.875-1.967c0.582-0.486,1.332-0.729,2.244-0.729c0.982,0,1.748,0.242,2.301,0.729 c0.551,0.486,0.826,1.145,0.826,1.975c0,0.434-0.152,0.895-0.461,1.381c-0.307,0.484-0.645,0.826-1.01,1.021 c0.463,0.215,0.891,0.602,1.285,1.164c0.393,0.561,0.59,1.088,0.59,1.582c0,1.016-0.32,1.805-0.961,2.369 c-0.639,0.564-1.508,0.846-2.607,0.846c-1.107,0-1.963-0.275-2.566-0.828c-0.604-0.551-0.904-1.348-0.904-2.387 c0-0.537,0.16-1.064,0.48-1.582C260.762,171.265,261.176,170.856,261.684,170.56z M263.266,171.327 c-0.932,0.527-1.398,1.207-1.398,2.037c0,0.459,0.145,0.84,0.436,1.143s0.668,0.453,1.131,0.453 c0.488,0,0.889-0.133,1.199-0.398c0.309-0.266,0.465-0.617,0.465-1.051C265.098,172.769,264.486,172.04,263.266,171.327z  M263.646,169.827c0.273-0.127,0.516-0.363,0.725-0.707c0.211-0.344,0.316-0.656,0.316-0.934c0-0.322-0.111-0.58-0.334-0.77 c-0.223-0.191-0.516-0.285-0.883-0.285c-0.811,0-1.215,0.354-1.215,1.061c0,0.313,0.148,0.633,0.445,0.957 C263,169.474,263.314,169.7,263.646,169.827z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M289.654,176.638l-1.01-1.068c1.484-0.82,2.533-1.893,3.148-3.217 c-0.326,0.146-0.744,0.221-1.252,0.221c-1.006,0-1.816-0.313-2.432-0.938s-0.924-1.475-0.924-2.549 c0-1.064,0.316-1.926,0.945-2.586c0.631-0.658,1.422-0.988,2.373-0.988c2.5,0,3.75,1.572,3.75,4.717 c0,1.309-0.482,2.633-1.447,3.973C291.844,175.544,290.793,176.354,289.654,176.638z M289.127,169.013 c0,0.602,0.143,1.074,0.426,1.422c0.283,0.346,0.645,0.52,1.084,0.52c1.094,0,1.641-0.609,1.641-1.83 c0-1.328-0.555-1.992-1.664-1.992c-0.453,0-0.814,0.166-1.084,0.502C289.262,167.968,289.127,168.427,289.127,169.013z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mom1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mom2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "mom3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "mom4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "mom5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "mom6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "mom7"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "mom8"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "mom9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorMomentum0);
export default __webpack_public_path__ + "static/media/indicator-momentum-0.7a9f0b8209cdf770120e5ecdfe548d52.svg";
export { ForwardRef as ReactComponent };